import { Button, PlusIcon } from "melco-ui";
import { useTranslation } from "react-i18next";

type AddSupplierProductButtonProps = {

  setIsAddSupplierProductDrawerOpenAction: (v: boolean) => void
};

export const AddSupplierProductButton: React.FC<
AddSupplierProductButtonProps
> = ({ setIsAddSupplierProductDrawerOpenAction }) => {
 // const [addSupplier, isLoading] = useAddSupplier(HOOPS);

  const { t } = useTranslation();
  return (
    <>
      {
        <Button
          key="add-hoops-suppliers"
          type="primary"
          icon={<PlusIcon />}
          onClick={async () => {
            setIsAddSupplierProductDrawerOpenAction(true);
           
          }}
        >
        {t("supplierproducts.actions.add.button")}
        </Button>
      }
    </>


  );
};
